<template>
  <v-app>
    <v-main style="padding: 0;">
      <router-view class="full-height" />
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import * as constants from "@/common/constants";

export default {
  computed: {
    ...mapGetters(["isLoggedIn"])
  }
};
</script>
